import { TSESTree } from '@typescript-eslint/types';

export class FunctionsModel {
  constructor(public target = '', public originalString = '', public functionTree: TSESTree.Program | null = null) {}
}
